// Stick Snak exit-intent popup.
// Desktop: opens when the cursor leaves the top of the viewport (exit intent).
// Mobile: opens after a delay once the visitor has engaged (no exit intent on touch).
// Suppressed by localStorage: not shown again within `frequency` days, and never
// again after a submit. Skipped on cart/checkout.
(function () {
  var root = document.querySelector('[data-ss-popup]');
  if (!root) return;

  var SEEN = 'ss_popup_seen';      // timestamp of last show
  var DONE = 'ss_popup_done';      // set after a submit — never show again
  var freqDays = parseInt(root.getAttribute('data-frequency'), 10) || 14;
  var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 10) * 1000;
  var opened = false;

  // Don't run on cart/checkout
  if (/\/(cart|checkout)(\/|$|\?)/.test(location.pathname)) return;

  function store(key) { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
  function get(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }

  function suppressed() {
    if (get(DONE)) return true;
    var seen = parseInt(get(SEEN), 10);
    if (seen && (Date.now() - seen) < freqDays * 864e5) return true;
    return false;
  }

  function open() {
    if (opened || suppressed()) return;
    opened = true;
    root.hidden = false;
    // force reflow so the transition runs
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    store(SEEN);
    var input = root.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus(); }, 50);
    teardown();
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 250);
  }

  // Triggers
  function onMouseOut(e) {
    if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) open();
  }
  var mobileTimer;
  function teardown() {
    document.removeEventListener('mouseout', onMouseOut);
    if (mobileTimer) clearTimeout(mobileTimer);
  }

  if (suppressed()) return;

  var isDesktop = window.matchMedia('(min-width: 750px) and (pointer: fine)').matches;
  if (isDesktop) {
    document.addEventListener('mouseout', onMouseOut);
  } else {
    // Mobile: open after the delay, but only once the visitor has scrolled a bit.
    mobileTimer = setTimeout(function () {
      if ((window.scrollY || 0) > 200) open();
      else window.addEventListener('scroll', function once() {
        window.removeEventListener('scroll', once); open();
      }, { passive: true });
    }, delayMs);
  }

  // Close interactions
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ss-popup-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // Mark done on submit (covers Shopify form reload + Klaviyo ajax)
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () { store(DONE); });
})();
